module.exports = __webpack_public_path__ + "media/images/avatar-1bc4b35cc444d9f22c5f9244cf93ae1f.png";